"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreManager = void 0;
var ScoreManager = /** @class */ (function () {
    function ScoreManager(_data) {
        this._data = _data;
        this.score = 0;
    }
    ScoreManager.prototype.incrementScore = function () {
        this.score++;
        this.save();
    };
    ScoreManager.prototype.decrementScore = function () {
        if (this.score > 0)
            this.score--;
        this.save();
    };
    ScoreManager.prototype.save = function () {
        var scoreData = this._data.get();
        if (this.score > scoreData.highestScore) {
            scoreData.highestScore = this.score;
            this._data.save(scoreData);
        }
    };
    ScoreManager.prototype.getScoreData = function () {
        var scoreData = this._data.get();
        return scoreData;
    };
    ScoreManager.prototype.getCurrentScore = function () {
        return this.score;
    };
    return ScoreManager;
}());
exports.ScoreManager = ScoreManager;
